import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BrandL } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

const TextContainer = styled(BodyL)`
  line-height: 1.7;
`;

export const AboutUs = () => {
  const isLaptop = useIsLaptop();
  return (
    <Container maxWidth={isLaptop ? 800 : 500}>
      <Vertical gap={isLaptop ? 6 : 2} center>
        <BrandL>
          <FormattedMessage defaultMessage="About us" />
        </BrandL>
        <Vertical gap={4} center>
          <TextContainer bold>
            <FormattedMessage defaultMessage="Sorare is revolutionising digital sports fandom, and has over 3 million users across 180 countries." />
          </TextContainer>
          <TextContainer>
            <FormattedMessage defaultMessage="More than 300 iconic teams, clubs, and organisations - including the Premier League, La Liga, Bundesliga, Serie A, MLS, NBA, NBPA, MLB, MLBPA - have partnered with Sorare in what is the largest portfolio in sports gaming." />
          </TextContainer>
          <TextContainer>
            <FormattedMessage defaultMessage="Backed by world-class investors including SoftBank, Accel, and Benchmark, Sorare is on a mission to become the future of global sports entertainment. " />
          </TextContainer>
          <TextContainer>
            <FormattedMessage defaultMessage="Legendary athletes like Kylian Mbappé, Serena Williams, Lionel Messi, Zinedine Zidane, Rio Ferdinand, Antoine Griezmann, Gerard Piqué, Blake Griffin, and Rudy Gobert have joined the journey as investors, ambassadors, and advisors." />
          </TextContainer>
        </Vertical>
      </Vertical>
    </Container>
  );
};
